var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGotoWod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.63 3L17.6604 0H-0.000391006V9.85714V16H7.65531H25.5996V6L21.63 3Z",
    fill: "url(#paint0_linear_1346_6086)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0293 10.0576H20.5722L14.826 5.94336",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1346_6086",
    x1: 25.5996,
    y1: 8.97436,
    x2: -0.00117947,
    y2: 8.76136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BD8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCFB85"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotoWod);
export default __webpack_public_path__ + "static/media/gotoWod.d011fd3b6b2f0313f91f9046e2b37ad4.svg";
export { ForwardRef as ReactComponent };